import { OperationOutcome, Patient } from '@medplum/fhirtypes';
import { useResource } from '@medplum/react';
import { useParams } from 'react-router-dom';

type Options = {
  patientId?: string;
  ignoreMissingPatientId?: boolean;
  setOutcome?: (outcome: OperationOutcome) => void;
};

export const usePatient = (options?: Options): Patient | undefined => {
  const { patientId } = useParams();
  if (!(patientId || options?.patientId) && !options?.ignoreMissingPatientId) {
    throw new Error('Patient ID not found');
  }

  const id = patientId || options?.patientId;
  return useResource<Patient>(
    { reference: `Patient/${id}` },
    options?.setOutcome
  );
};
